import { MUSIC_PLAYER_CONST } from "@components/player-modal/constant";

export const PORTFOLIO_CONSTS = {
  PORTFOLIO: 'Portfolio',
  BUTTON_LABEL: 'Button Label',
  DISPLAY_MY_PORTFOLIO: 'Display My Portfolio',
  ITEMS: 'Items',
  ITEM: 'Item',
  ADD: 'Add',
  NO_PORTFOLIO_ITEMS_MSG: 'You have not added any Portfolio items yet.',
  DISCOGRAPHY: 'Discography',
  CONFIRM: 'Confirm',
  ADD_ITEM_TO_PORTFOLIO: 'Add item to Portfolio',
  EDIT_PORTFOLIO_ITEM: 'Edit Portfolio Item',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  PORTFOLIO_SET_MSG:
    'Please add an item to enable portfolio on your TopFan site',
  CREATE_CUSTOM_DSP: 'Create Custom DSP',
  BACK_TO: 'Back to',
  DELETE_MSG: 'Are you sure you want to delete this Portfolio Item?',
  DELETE_ITEM: 'Delete Item',
  BUTTON_LABEL_MSG:
    'You can change label on the button that takes fans to your Portfolio (i.e., it can say Discography, Books or Movies)',
  COVER_IMG_SUC_MSG: 'Cover image updated successfully.',
  HEADING_SUC_MSG: 'Portfolio heading updated successfully.',
  BUTTON_LABEL_SUC_MSG: 'Button Label updated successfully.',
  PORTFOLIO_DISABLES_MSG: 'Portfolio is disabled on your TopFan site.',
  PORTFOLIO_ENABLES_MSG: 'Portfolio is now displaying on your TopFan site.',
  HORIZONTAL: 'horizontal',
  PROCEED: 'Proceed',
  SELECT_PORTFOLIO_SHAPE: 'Select Portfolio Images Shape',
  RECTANGLE: 'rectangle',
  SQUARE: 'square',
  NAVIGATE_TO_ADD: 'navigate to add',
  ALBUM_DESCRIPTION: 'Album Description',
  UNLOCK: 'Unlock ',
  RECTANGLE_DIMENSION: {
    HEIGHT: '360',
    WIDTH: '242',
    DETAILS_PAGE_HEIGHT: '560',
    DETAILS_PAGE_WIDTH: '376',
    ASPECT_RATIO: '0.6709677419354839',
    DESCRIPTION_BOX_HEIGHT: '212'
  },
  SQUARE_DIMENSION: {
    HEIGHT: '250',
    DETAILS_PAGE_HEIGHT: '450',
    DETAILS_PAGE_WIDTH: '450',
    WIDTH: '250',
    ASPECT_RATIO: '1',
    DESCRIPTION_BOX_HEIGHT: '104'
  },
  SHAPE_MSG:
    'Note: Please choose the shape of the imagery that you will display in your Portfolio: Square or Tall Rectangle. For example, Square is best for music album art, and Tall Rectangle is typically best for movie posters and books. If you change your mind on the image shape, you will need to delete your portfolio items and start over.',
  UPDATE: 'Update',
  ALBUM_HAS_NO_SONGS_MSG: 'Album has no songs yet.',
  MUSIC_ALBUM_CATEGORY: 'Music/Album',
  INDIVIDUAL_SONG_CATEGORY: 'Music',
  MUSIC_ALBUM_SHARE_MSG: 'Music Album',
  PODCAST_ALBUM_SHARE_MSG: 'Podcast Series',
  VIDEO_SERIES_SHARE_MSG: 'Video Series',
  COLLECTION_ITEM_SHARE_MSG: 'Custom Portfolio Collection',
  INDIVIDUAL_PODCAST_SHARE_MSG: 'Podcast',
  INDIVIDUAL_VIDEO_SHARE_MSG: 'Video',
  INDIVIDUAL_MUSIC_SHARE_MSG: 'Song',
  INDIVIDUAL_CUSTOM_ITEM_SHARE_MSG: 'Custom Portfolio Item',
  SONG: 'Song',
  SONGS: 'Songs',
  INDIVIDUAL_SONGS_EMPTY_MSG: 'No Songs Added Yet',
  MUSIC: 'Music',
  PODCAST_SERIES_DESCRIPTION: 'Podcast Series Description',
  VIDEO_SERIES_DESCRIPTION: 'Video Series Description',
  COLLECTION_DESCRIPTION: 'Collection Description',
  PODCAST: 'Podcast',
  PODCASTS: 'Podcasts',
  SONG_DESCRIPTION: 'Song Description',
  PODCAST_DESCRIPTION: 'Podcast Description',
  VIDEO_DESCRIPTION: 'Video Description',
  ITEM_DESCRIPTION: 'Item Description',
  SINGLE_ITEM_EMPTY_MSG: {
    MUSIC: 'No Songs Added Yet',
    PODCAST: 'No Podcasts Added Yet',
    VIDEO: 'No Videos Added Yet',
    CUSTOM: 'No Items Added Yet'
  },
  SINGLE_ITEM_EMPTY_ICON: {
    MUSIC: 'icon-litemusic-node-2',
    PODCAST: 'icon-liteMIc-Icon',
    VIDEO: 'icon-litevideo-fill-camera',
    CUSTOM: 'icon-litesuitcase'
  },
  PREVIEW_PROCESSING_MSG: 'Processing...',
  DISABLED_STATUS_MSG: 'Disabled',
  VIEW: 'View',
  CUSTOM_PORTFOLIO_CROPPER_TEXT: 'Recommended Minimum Size: 500px Wide',
  BADGE_GROUPS_HINT: 'If a Group(s) is selected in this list, only users belonging to that Group will see this Portfolio Item.'
};

export const PORTFOLIO_MASTER_ITEM_TYPE = {
  MUSIC: 'BUY ALBUM',
  PODCAST: 'BUY SERIES',
  VIDEO: 'BUY SERIES',
  CUSTOM: 'BUY ITEM',
};

export const PORTFOLIO_ADD_ITEM_LABEL = {
  MUSIC: 'ADD SONG TRACK',
  PODCAST: 'ADD PODCAST EPISODE',
  VIDEO: 'ADD VIDEO',
  CUSTOM: 'ADD COLLECTION ITEM'
}

export const PURCHASE_TEXT_MAP = {
  MUSIC: {
    SINGLE: {
      INDIVIDUAL_PURCHASE: MUSIC_PLAYER_CONST.PURCHASE_MUSIC,
      SUBSCRIPTION: MUSIC_PLAYER_CONST.PURCHASE_MUSIC_VIA_SUBSCRIPTION,
      NFT: MUSIC_PLAYER_CONST.PURCHASE_MUSIC_BY_NFT,
    },
    MASTER: {
      INDIVIDUAL_PURCHASE: MUSIC_PLAYER_CONST.PURCHASE_ALBUM,
      SUBSCRIPTION: MUSIC_PLAYER_CONST.PURCHASE_ALBUM_VIA_SUBSCRIPTION,
      NFT: MUSIC_PLAYER_CONST.PURCHASE_ALBUM_BY_NFT,
    }
  },
  VIDEO: {
    SINGLE: {
      INDIVIDUAL_PURCHASE: MUSIC_PLAYER_CONST.PURCHASE_VIDEO,
      SUBSCRIPTION: MUSIC_PLAYER_CONST.PURCHASE_VIDEO_VIA_SUBSCRIPTION,
      NFT: MUSIC_PLAYER_CONST.PURCHASE_VIDEO_BY_NFT,
    },
    MASTER: {
      INDIVIDUAL_PURCHASE: MUSIC_PLAYER_CONST.PURCHASE_SERIES,
      SUBSCRIPTION: MUSIC_PLAYER_CONST.PURCHASE_SERIES_VIA_SUBSCRIPTION,
      NFT: MUSIC_PLAYER_CONST.PURCHASE_SERIES_BY_NFT,
    },
  },
  PODCAST: {
    SINGLE: {
      INDIVIDUAL_PURCHASE: MUSIC_PLAYER_CONST.PURCHASE_PODCAST,
      SUBSCRIPTION: MUSIC_PLAYER_CONST.PURCHASE_PODCAST_VIA_SUBSCRIPTION,
      NFT: MUSIC_PLAYER_CONST.PURCHASE_PODCAST_BY_NFT,
    },
    MASTER: {
      INDIVIDUAL_PURCHASE: MUSIC_PLAYER_CONST.PURCHASE_SERIES,
      SUBSCRIPTION: MUSIC_PLAYER_CONST.PURCHASE_SERIES_VIA_SUBSCRIPTION,
      NFT: MUSIC_PLAYER_CONST.PURCHASE_SERIES_BY_NFT,
    },
  },
  CUSTOM: {
    SINGLE: {
      INDIVIDUAL_PURCHASE: MUSIC_PLAYER_CONST.PURCHASE_ITEM,
      SUBSCRIPTION: MUSIC_PLAYER_CONST.PURCHASE_ITEM_VIA_SUBSCRIPTION,
      NFT: MUSIC_PLAYER_CONST.PURCHASE_ITEM_BY_NFT,
    },
    MASTER: {
      INDIVIDUAL_PURCHASE: MUSIC_PLAYER_CONST.PURCHASE_COLLECTION,
      SUBSCRIPTION: MUSIC_PLAYER_CONST.PURCHASE_COLLECTION_VIA_SUBSCRIPTION,
      NFT: MUSIC_PLAYER_CONST.PURCHASE_COLLECTION_BY_NFT,
    },
  },
  COURSE: {
    SINGLE: {
      INDIVIDUAL_PURCHASE: MUSIC_PLAYER_CONST.PURCHASE_COURSE,
      SUBSCRIPTION: MUSIC_PLAYER_CONST.PURCHASE_COURSE_VIA_SUBSCRIPTION,
      NFT: MUSIC_PLAYER_CONST.PURCHASE_COURSE_BY_NFT,
    },
  },
};

export const PORTFOLIO_TYPE_CONSTS = {
  portfolio_music: 'portfolio_music',
  portfolio_podcast: 'portfolio_podcast',
  portfolio_video: 'portfolio_video',
  IMAGE_SM: 'image',
  video_series: 'video_series',
  music_album: 'music_album',
  podcast_series: 'podcast_series'
};

export const PORTFOLIO_PROFILE_ROUTES = {
  portfolio_music: 'music-detail',
  portfolio_podcast: 'podcast-detail',
  portfolio_video: 'video-detail',
  video_series: 'video-series',
  music_album: 'music-album',
  podcast_series: 'podcast-series',
  MUSIC: 'music-detail',
  PODCAST: 'podcast-detail',
  VIDEO: 'video-detail',
};

export const PORTFOLIO_TYPE_ROUTE_PATH_MAP = {
  portfolio_music: 'MUSIC',
  portfolio_podcast: 'PODCAST',
  portfolio_video: 'VIDEO',
  music_album: 'MUSIC',
  podcast_series: 'PODCAST',
  video_series: 'VIDEO',
};

export const PROFILE_PORTFOLIO_TYPE_MAP = {
  portfolio_music: 'MUSIC',
  portfolio_podcast: 'PODCAST',
  portfolio_video: 'VIDEO',
  music_album: 'MUSIC',
  podcast_series: 'PODCAST',
  video_series: 'VIDEO',
};

export const PORTFOLIO_TYPE_SM_MAP = ['portfolio_music', 'portfolio_podcast', 'portfolio_video', 'video_series', 'music_album', 'podcast_series', 'image'];

export const PORTFOLIO_TYPE_SM_MAP_WO_IMAGE = ['portfolio_music', 'portfolio_podcast', 'portfolio_video', 'video_series', 'music_album', 'podcast_series'];

/** Copy for portfolio unlock flow using loyalty points (modal header). */
export const PORTFOLIO_UNLOCK_LOYALTY_TEXT = {
  UNLOCK_PORTFOLIO_WITH_POINTS_MODAL_HEADER: 'Unlock with Points'
} as const;

export const PORTFOLIO_CTA_TYPE_MAP = {
  [PORTFOLIO_TYPE_CONSTS.portfolio_music]: 'Listen to Song',
  [PORTFOLIO_TYPE_CONSTS.portfolio_podcast]: 'Listen to Podcast',
  [PORTFOLIO_TYPE_CONSTS.portfolio_video]: 'Watch Video',
  [PORTFOLIO_TYPE_CONSTS.video_series]: 'Watch Series',
  [PORTFOLIO_TYPE_CONSTS.music_album]: 'Listen to Album',
  [PORTFOLIO_TYPE_CONSTS.podcast_series]: 'Listen to Series',
};

/** API `parent_details.type` values (lowercase from backend). */
export const PORTFOLIO_PARENT_DETAILS_TYPE = {
  PORTFOLIO: 'portfolio',
  ALBUM: 'album'
} as const;

export function normalizePortfolioParentDetailsType(
  type: string | undefined
): string {
  return (type || '').toLowerCase();
}

export function isPortfolioParentDetailsType(
  type: string | undefined
): boolean {
  return (
    normalizePortfolioParentDetailsType(type) ===
    PORTFOLIO_PARENT_DETAILS_TYPE.PORTFOLIO
  );
}

export function isAlbumParentDetailsType(type: string | undefined): boolean {
  return (
    normalizePortfolioParentDetailsType(type) ===
    PORTFOLIO_PARENT_DETAILS_TYPE.ALBUM
  );
}

/** Discriminators for individual music / item detail breadcrumb trail. */
export const INDIVIDUAL_MUSIC_BREADCRUMB_KIND = {
  HUB: 'hub',
  HUB_PORTFOLIO_LABEL: 'hub-portfolio-label',
  PARENT_PORTFOLIO: 'parent-portfolio',
  PORTFOLIO_TITLE: 'portfolio-title',
  PARENT_ALBUM: 'parent-album',
  CURRENT: 'current'
} as const;

export type IndividualMusicBreadcrumbKind =
  (typeof INDIVIDUAL_MUSIC_BREADCRUMB_KIND)[keyof typeof INDIVIDUAL_MUSIC_BREADCRUMB_KIND];

export interface IndividualMusicBreadcrumbItem {
  kind: IndividualMusicBreadcrumbKind;
  label: string;
  isCurrent: boolean;
}